import React, { useEffect, useState } from "react";
import { useAuth } from "../services/auth.service";
import axios from "axios";
import XLSX from "xlsx";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import MD5 from "md5";

export default function CustomExcel() {
    const { user } = useAuth();

    const [templates, setTemplates] = useState([]);

    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const [readedData, setReadedData] = useState([]);

    const [search, setSearch] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const [columnFilters, setColumnFilters] = useState({});
    const [showColumnFilters, setShowColumnFilters] = useState(true);
    const [customFixedInput, setCustomFixedInput] = useState("");
    const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);
    const [phoneConfig, setPhoneConfig] = useState({
        autoFormat: true,
        defaultCountryCode: "507",
        cleanNonDigits: true,
        saveToContacts: true,
    });

    //driverjs
    const driverObj = driver({
        showProgress: true,
        steps: [
            { element: "#recentfiles", popover: { title: 'Archivos recientes', description: "Selecciona un archivo reciente para cargarlo en la tabla, alternativamente puedes cargarlo mediante el boton cargar excel" } },
            { element: "#loadexcelfile", popover: { title: 'Cargar archivo', description: "Carga un archivo de excel desde tu ordenador, automaticamente se ingresa en la tabla, tambien puedes seleccionar un archivo reciente que hayas usado anteriormente" } },
            { element: "#selecttemplate", popover: { title: 'Seleccionar plantilla de WA', description: "Selecciona una plantilla de Whatsapp para enviar mensajes" } },
            { element: "#templatemessage", popover: { title: 'Plantilla Cargada', description: "Al seleccionar una plantilla automaticamente se muestra en esta sección, puedes seleccionar variables para agregarlas al mensaje" } },
            { element: "#selectejecutivo", popover: { title: 'Seleccionar ejecutivo', description: "Selecciona un ejecutivo para asignarlo a los mensajes enviados" } },
            { element: "#columnnames", side: 'bottom', align: 'end', popover: { title: 'Columnas para plantilla', description: "Haz click en el nombre de la columna que quieras agregar a tu plantilla de Whatsapp y se agregará la variable en el orden de selección" } },
            { element: "#selectphone", popover: { title: 'Columna de telefono', description: "Selecciona una columna que corresponda con el numero de telefono de los destinatarios" } },
            { element: "#checkbox-table-search-1", popover: { title: 'Seleccionar filas a enviar', description: "Selecciona una o varias filas a las que desees enviar mensajes" } },
            { element: "#sendtemplate", popover: { title: 'Enviar mensajes', description: "Envía los mensajes utilizando las filas de la tabla seleccionadas" } },
        ]
    })

    const readExcelFile = (file) => {
        toast.info(`Leyendo archivo ${file.name}`);
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;

                const wb = XLSX.read(bufferArray, { type: "buffer" });

                const wsname = wb.SheetNames[0];

                const ws = wb.Sheets[wsname];

                const data = XLSX.utils.sheet_to_json(ws);

                resolve(data);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });

        promise.then((d) => {
            //append a new column to the data with the checkbox
            d = d.map((row) => {
                return {
                    ...row,
                    checked: false,
                    sheettitle: file.name,
                    messageStatus: [
                        {
                            id: 0,
                            sentTemplate: "Sin plantillas",
                            status: "not sent"
                        }
                    ]
                }
            });
            async function loadSheets() {
                const url = process.env.REACT_APP_BACKEND_API + "/customexcel";
                const config = {
                    headers: {
                        "x-access-token": user.accessToken,
                        "Content-Type": "application/json",
                    },
                };
                let result = []
                try {
                    result = await axios
                        .post(url, JSON.stringify({ data: d }), config)
                        .then((response) => {
                            return response.data;
                        }
                        )
                        .catch((error) => {
                            return d;
                        }
                        );
                } catch (error) {
                    result = d;
                }

                if (result) {
                    toast.success(`Archivo ${file.name} cargado`);
                    setReadedData(result);
                    //set the sheets array with the new sheet
                    if (!sheets.includes(result.sheettitle)) {
                        setSheets([...sheets, result.sheettitle]);
                    }
                }
            }
            loadSheets();
        });
    }

    const dataColumnNames = (data) => {
        if (data.length > 0) {
            return Object.keys(data[0]);
        }
        return [];
    }

    const getNameDataFromIndex = (index) => {
        return Object.keys(readedData[0])[index];
    }

    const checkIndividual = (e, targetRow) => {
        setReadedData(readedData.map((row) => {
            if (row === targetRow || (row._id && row._id === targetRow._id)) {
                return {
                    ...row,
                    checked: e.target.checked
                };
            }
            return row;
        }));
    };

    const handleCellEdit = (targetRow, key, value) => {
        setReadedData(readedData.map((row) => {
            if (row === targetRow || (row._id && row._id === targetRow._id)) {
                return {
                    ...row,
                    [key]: value
                };
            }
            return row;
        }));
    };

    const handleCellBlur = (targetRow) => {
        const updatedRow = readedData.find((row) => row === targetRow || (row._id && row._id === targetRow._id));
        if (updatedRow && updatedRow._id) {
            updateRowAPI(updatedRow);
        }
    };

    const handleSort = (columnName) => {
        let direction = "asc";
        if (sortConfig.key === columnName && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key: columnName, direction });
    };

    const handleAddCustomFixedValue = () => {
        if (!customFixedInput || customFixedInput.trim() === "") {
            toast.error("Ingresa un valor fijo válido");
            return;
        }
        const val = `FIXED_VAL:${customFixedInput.trim()}`;
        if (!selectedVariables.includes(val)) {
            setSelectedVariables([...selectedVariables, val]);
            setCustomFixedInput("");
            toast.success(`Valor fijo "${customFixedInput.trim()}" agregado`);
        } else {
            toast.info("Este valor fijo ya fue agregado");
        }
    };

    const removeVariableIndex = (indexToRemove) => {
        setSelectedVariables(selectedVariables.filter((_, idx) => idx !== indexToRemove));
        const spans = document.querySelectorAll("span[data-type=variable]");
        if (spans[indexToRemove]) {
            spans[indexToRemove].innerHTML = `${indexToRemove + 1}`;
        }
    };

    const handleColumnFilterChange = (columnName, value) => {
        setColumnFilters((prev) => ({
            ...prev,
            [columnName]: value
        }));
    };

    const clearAllFilters = () => {
        setColumnFilters({});
        setSearch("");
    };

    const sortedData = React.useMemo(() => {
        let items = [...readedData];

        // 1. Filter items based on global search and per-column filters
        items = items.filter((row) => {
            if (search && search.trim() !== "") {
                const searchLower = search.toLowerCase();
                const matchesGlobal = Object.values(row).some((val) =>
                    val !== null && val !== undefined && val.toString().toLowerCase().includes(searchLower)
                );
                if (!matchesGlobal) return false;
            }

            for (const [colKey, filterVal] of Object.entries(columnFilters)) {
                if (!filterVal || filterVal.trim() === "") continue;
                const filterLower = filterVal.toLowerCase();
                if (colKey === "messageStatus") {
                    const statusStr = Array.isArray(row.messageStatus)
                        ? row.messageStatus.map((s) => `${s.sentTemplate}:${s.status}`).join(" ")
                        : "";
                    if (!statusStr.toLowerCase().includes(filterLower)) return false;
                } else {
                    const cellValue = row[colKey];
                    if (cellValue === null || cellValue === undefined) return false;
                    if (!cellValue.toString().toLowerCase().includes(filterLower)) return false;
                }
            }
            return true;
        });

        // 2. Sort items
        if (sortConfig.key !== null) {
            items.sort((a, b) => {
                const aVal = a[sortConfig.key] !== undefined && a[sortConfig.key] !== null ? a[sortConfig.key] : "";
                const bVal = b[sortConfig.key] !== undefined && b[sortConfig.key] !== null ? b[sortConfig.key] : "";
                if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
                if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
                return 0;
            });
        }
        return items;
    }, [readedData, sortConfig, columnFilters, search]);

    const formatPhoneNumber = (phone, config = phoneConfig) => {
        if (!phone) return "";
        let str = String(phone).trim();
        if (config.cleanNonDigits) {
            str = str.replace(/\D/g, "");
        }
        if (config.defaultCountryCode && str.length > 0) {
            const code = config.defaultCountryCode.trim().replace(/\D/g, "");
            if (code && !str.startsWith(code)) {
                str = code + str;
            }
        }
        return str;
    };

    const applyPhoneFormattingToTable = () => {
        if (!selectedPhoneColumn) {
            toast.error("Selecciona primero una columna de teléfono");
            return;
        }
        const updated = readedData.map((row) => {
            const formatted = formatPhoneNumber(row[selectedPhoneColumn]);
            return {
                ...row,
                [selectedPhoneColumn]: formatted
            };
        });
        setReadedData(updated);
        toast.success("Teléfonos formateados en la tabla");
    };

    const checkAll = (e) => {
        const visibleIds = new Set(sortedData.map(r => r._id || r));
        setReadedData(readedData.map((row) => {
            const identifier = row._id || row;
            if (visibleIds.has(identifier)) {
                return {
                    ...row,
                    checked: e.target.checked
                };
            }
            return row;
        }));
    };

    useEffect(() => {
        if (templates.length > 0) return;
        async function loadTemplates() {
            const url = process.env.REACT_APP_BACKEND_API + "/template";
            const config = {
                headers: {
                    "x-access-token": user.accessToken,
                    "Content-Type": "application/json",
                },
            };
            let result = await axios
                .get(url, config)
                .then((response) => {
                    return response;
                })
                .catch((error) => {
                    return error;
                });
            if (result.data) {
                //translate each template
                result.data = result.data.map((template) => {
                    if (template.body)
                        template.body = translate(template.body);
                    return template;
                })
                setTemplates(result.data);
            }
        }
        loadTemplates();

    }, [templates, user.accessToken]);

    const [selectedEjecutivo, setSelectedEjecutivo] = useState(null);
    const [ejecutivos, setEjecutivos] = useState([]);

    useEffect(() => {
        if (ejecutivos.length > 0) return;
        async function loadEjecutivos() {
            const url = process.env.REACT_APP_BACKEND_API + "/ejecutivo";
            const config = {
                headers: {
                    "x-access-token": user.accessToken,
                    "Content-Type": "application/json",
                },
            };
            let result = await axios
                .get(url, config)
                .then((response) => {
                    return response;
                })
                .catch((error) => {
                    return error;
                });
            if (result.data) {
                setEjecutivos(result.data);
            }
        }
        loadEjecutivos();

    }, [ejecutivos, user.accessToken]);

    const handleSelectedEjecutivo = (e) => {
        //search the ejecutivo object with the id
        setSelectedEjecutivo(ejecutivos.find((ejecutivo) => ejecutivo._id === e));
    }

    const [sheets, setSheets] = useState([]);

    useEffect(() => {
        if (sheets.length > 0) return;
        async function loadSheets() {
            const url = process.env.REACT_APP_BACKEND_API + "/customexcel";
            const config = {
                headers: {
                    "x-access-token": user.accessToken,
                    "Content-Type": "application/json",
                },
            };
            let result = await axios
                .get(url, config)
                .then((response) => {
                    return response;
                })
                .catch((error) => {
                    return error;
                });
            if (result.data) {
                setSheets(result.data);
            }
        }
        loadSheets();
    }, [sheets, user.accessToken]);

    const loadExcelFromAPI = (e) => {
        e.preventDefault();
        toast.info(`Cargando archivo ${e.target.value}`);
        async function loadSheets() {
            const url = process.env.REACT_APP_BACKEND_API + "/customexcel/" + e.target.value;
            const config = {
                headers: {
                    "x-access-token": user.accessToken,
                    "Content-Type": "application/json",
                },
            };
            let result = await axios
                .get(url, config)
                .then((response) => {
                    return response;
                })
                .catch((error) => {
                    return error;
                });
            if (result.data) {
                setReadedData(result.data);
                toast.success(`Archivo ${e.target.value} cargado`);
            }
        }
        loadSheets();
    }

    useEffect(() => {
        //change the body of the template with translate
        if (!selectedTemplate) return;
        const spans = document.querySelectorAll("span[contenteditable=true]");
        setSelectedVariables([]);
        spans.forEach((span) => {
            span.addEventListener("click", (e) => {
                //remove the selectedVariables item with the innerHTML
                setSelectedVariables(selectedVariables.filter((variable) => variable !== e.target.innerHTML));
            });
        }
        );
    }, [selectedTemplate]);

    function translate(text) {
        text = text.replace(/\{\{(\d+)\}\}/g, (match, number) => {
            return `<span data-type="variable" data-index="${number}" style="white-space: nowrap;">${number}</span>`;
        });
        // Add line breaks
        text = text.replace(/\n/g, '<br>');

        // Replace bold and italic formatting
        text = text.replace(/\*(.*?)\*/g, '<b>$1</b>');
        text = text.replace(/_(.*?)_/g, '<i>$1</i>');

        // Combine remaining formatting
        //text = text.replace(/(<i>.*)(<b>.*<\/b>.*<\/i>)/g, '$2$1');


        return text;
    }

    const [selectedVariables, setSelectedVariables] = useState([]);

    const [isUUIDVariable, setIsUUIDVariable] = useState(false);

    useEffect(() => {
        if (selectedVariables.length === 0 || selectedTemplate === null) return;
        const spans = document.querySelectorAll("span[data-type=variable]");
        const currentIndex = selectedVariables.length - 1;
        if (!selectedTemplate.parameters) return;
        const maxVars = (selectedTemplate.parameters.length + (selectedTemplate.comparacionValores ? selectedTemplate.comparacionValores.length : 0) + (selectedTemplate.compositeVariables ? selectedTemplate.compositeVariables.length : 0) + (selectedTemplate.fixedVariableValues ? selectedTemplate.fixedVariableValues.length : 0));
        if (currentIndex >= maxVars) {
            setSelectedVariables(selectedVariables.filter((_, index) => index !== currentIndex));
            if (selectedTemplate.buttonparameters && selectedTemplate.buttonparameters.length > 0 && selectedButtonParameters.length < selectedTemplate.buttonparameters.length) {
                toast.info("Agregando variable a botones");
                setSelectedButtonParameters([...selectedButtonParameters, selectedVariables[currentIndex]]);
                if (selectedVariables[currentIndex].toLowerCase() === "uuid") {
                    setIsUUIDVariable(true);
                }
            } else {
                toast.error("No puedes agregar más variables");
            }
            return;
        }
        if (spans[currentIndex]) {
            const rawVal = selectedVariables[currentIndex];
            spans[currentIndex].innerHTML = rawVal.startsWith("FIXED_VAL:") ? `"${rawVal.replace("FIXED_VAL:", "")}"` : rawVal;
        }
    }, [selectedVariables]);

    const [isSendingMessages, setIsSendingMessages] = useState(false);

    const [isSendingOnBackground, setIsSendingOnBackground] = useState(false);

    const sendTemplateMessage = (e) => {
        const isBackground = isSendingOnBackground;
        e.preventDefault();
        if (isSendingMessages) {
            return;
        }
        if (selectedVariables.length === 0) {
            toast.error("No hay variables seleccionadas");
            return;
        }
        if (readedData.filter((readData) => readData.checked === true).length === 0) {
            toast.error("No hay mensajes seleccionados");
            return;
        }
        //check if the length of variables is equal than selectedTemplate.parameters
        if (selectedVariables.length !== (selectedTemplate.parameters.length + selectedTemplate.comparacionValores.length + selectedTemplate.compositeVariables.length + selectedTemplate.fixedVariableValues.length)) {
            toast.error("El número de variables seleccionadas no coincide con el número de variables de la plantilla");
            return;
        }
        if (!selectedPhoneColumn) {
            toast.error("No se ha seleccionado la columna de teléfonos");
            return;
        }
        isBackground ? toast.info(`Enviando en segundo plano ${readedData.filter((readData) => readData.checked === true).length} mensajes `) : toast.info(`Enviando ${readedData.filter((readData) => readData.checked === true).length} mensajes `);
        //validates selectedTemplate in case of the user changes the template during the sending process
        const selectedTemplateForSending = selectedTemplate;

        //rows length 
        const rowsLength = readedData.filter((readData) => readData.checked === true).length;
        //send message each 6 seconds
        readedData.filter((readData) => readData.checked === true).forEach((readData, index) => {
            setTimeout(() => {
                const rawPhone = readData[selectedPhoneColumn];
                const recipientPhone = phoneConfig.autoFormat ? formatPhoneNumber(rawPhone, phoneConfig) : rawPhone;

                if (phoneConfig.saveToContacts) {
                    const contactPayload = {
                        wa_id: recipientPhone,
                        ...(selectedEjecutivo ? {
                            ejecutivoAsignado: {
                                value: selectedEjecutivo._id,
                                label: `${selectedEjecutivo.firstName} ${selectedEjecutivo.lastName}`,
                                selected: true
                            }
                        } : {})
                    };
                    const customData = {};
                    Object.keys(readData).forEach((col) => {
                        if (["checked", "sheettitle", "_id", "messageStatus"].includes(col)) return;
                        contactPayload[col] = readData[col];
                        customData[col] = readData[col];
                        const lowerCol = col.toLowerCase().replace(/[^a-z]/g, '');
                        if (["nombre", "nombrecompleto", "client", "cliente"].includes(lowerCol)) {
                            contactPayload.NombreCompleto = readData[col];
                        }
                        if (["poliza", "nropoliza", "numeropoliza"].includes(lowerCol)) {
                            contactPayload.poliza = readData[col];
                        }
                    });
                    contactPayload.customData = customData;
                    contactPayload.excelData = customData;

                    fetch(`${process.env.REACT_APP_BACKEND_API}/contacts/${recipientPhone}`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            "x-access-token": user.accessToken,
                        },
                        body: JSON.stringify(contactPayload),
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            console.log('Success updating contact:', data);
                        })
                        .catch((err) => console.error(err));
                }

                //now send the message
                fetch(process.env.REACT_APP_BACKEND_API + (isBackground ? "/customexcelbackground" : "/messages/sendtemplatemessage"), {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": user.accessToken,
                    },
                    body:
                        selectedTemplate.type !== "quickreply" ?
                            JSON.stringify({
                                templateID: selectedTemplateForSending.name,
                                to: recipientPhone,
                                parameters: selectedVariables.map((parameter) => {
                                    const val = parameter.startsWith("FIXED_VAL:") ? parameter.replace("FIXED_VAL:", "") : readData[parameter];
                                    return { type: "text", value: val !== undefined && val !== null ? val : "" };
                                }),
                                header: {
                                    image: selectedTemplateForSending.image,
                                },
                                buttonParametersIndex: selectedTemplateForSending.buttonparameterindex,
                                buttonParameters:
                                    selectedTemplateForSending.buttonparameters.length > 0 ?
                                        selectedButtonParameters.map((buttonparameter) => {
                                            const val = buttonparameter.startsWith("FIXED_VAL:")
                                                ? buttonparameter.replace("FIXED_VAL:", "")
                                                : (isUUIDVariable ? MD5(readData[buttonparameter]) : readData[buttonparameter]);
                                            return { type: "text", value: val !== undefined && val !== null ? val : "" };
                                        }) : [],
                                subscribedTo: readData._id,
                                subscribedObjectId: "",
                            }) :
                            JSON.stringify({
                                templateID: selectedTemplateForSending.name,
                                to: recipientPhone,
                                parameters: selectedVariables.map((parameter) => {
                                    const val = parameter.startsWith("FIXED_VAL:") ? parameter.replace("FIXED_VAL:", "") : readData[parameter];
                                    return { type: "text", value: val !== undefined && val !== null ? val : "" };
                                }),
                                quickReplies: true,
                                dataId: `${readData._id} customexcel`,
                                header: {
                                    image: selectedTemplateForSending.image,
                                },
                                buttonParametersIndex: selectedTemplateForSending.buttonparameterindex,
                                buttonParameters:
                                    selectedTemplateForSending.buttonparameters.length > 0 ?
                                        selectedButtonParameters.map((buttonparameter) => {
                                            const val = buttonparameter.startsWith("FIXED_VAL:")
                                                ? buttonparameter.replace("FIXED_VAL:", "")
                                                : readData[buttonparameter];
                                            return { type: "payload", value: val !== undefined && val !== null ? val : "" };
                                        }) : [],
                                subscribedTo: "",
                                subscribedObjectId: "",
                            })
                }).then((response) => {
                    if (response.ok) {
                        if (isBackground) return;
                        toast.success(`Mensaje enviado a ${recipientPhone}`);
                        //catch response.json() promise
                        Promise.resolve(response.json()).then((jsonRes) => {
                            if (jsonRes.error) {
                                toast.error(`Error al enviar mensaje a ${recipientPhone}`);
                                return
                            }
                            if (jsonRes.messages && jsonRes.messages[0])
                                setReadedData(readedData.map((row) => {
                                    if (row._id === readData._id) {
                                        return {
                                            ...row,
                                            messageStatus: row.messageStatus.filter((status) => status.id !== 0).concat({
                                                id: jsonRes.messages[0].id,
                                                sentTemplate: selectedTemplateForSending.name,
                                                status: jsonRes.messages[0].message_status
                                            }),
                                        }
                                    }
                                    return row;
                                }))
                            let updatedReadData = {
                                ...readData, messageStatus: readData.messageStatus.filter((status) => status.id !== 0).concat({
                                    id: (jsonRes.messages && jsonRes.messages[0]) ? jsonRes.messages[0].id : 1,
                                    sentTemplate: selectedTemplateForSending.name,
                                    status: (jsonRes.messages && jsonRes.messages[0]) ? jsonRes.messages[0].message_status : "sent"
                                })
                            }
                            updateRowAPI(updatedReadData)
                        }
                        );
                        //check if its the last message
                        if (index === rowsLength - 1) {
                            //uncheck all
                            setReadedData(readedData.map((row) => {
                                return {
                                    ...row,
                                    checked: false
                                }
                            }));
                            setIsSendingMessages(false);
                        }
                    } else {
                        toast.error(`Error al enviar mensaje a ${recipientPhone}`);
                    }
                })
            }, index * (isBackground ? 5 : 6000));
        });
    }

    const updateRowAPI = (row) => {
        let rowCopyWithoutID = { ...row };
        delete rowCopyWithoutID._id;
        try {
            fetch(process.env.REACT_APP_BACKEND_API + "/customexcel/" + row._id, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": user.accessToken,
                },
                body: JSON.stringify(rowCopyWithoutID),
            }).then((response) => {
                if (response.ok) {
                    console.log("row updated");
                } else {
                    console.log("error updating row");
                }
            });
        } catch (e) {
            console.log(e);
        }
    }

    const [selectedButtonParameters, setSelectedButtonParameters] = useState([]);

    const changeSelectedTemplate = (e) => {
        e.preventDefault();
        setSelectedTemplate(templates.find((template) => template._id === e.target.value));
    }

    const [selectedPhoneColumn, setSelectedPhoneColumn] = useState(null);

    return (
        <>

            <div className="flex flex-column">
                <div key={1} className="relative overflow-x-auto shadow-md sm:rounded-lg px-4 mt-4" style={{ flex: '3' }}>
                    <div className="flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center justify-between">
                        <div
                            className="flex items-center space-x-4 sm:space-x-0 sm:space-y-0 sm:flex-row flex-wrap gap-x-4 gap-y-0"
                        >
                            <select id="recentfiles" onChange={loadExcelFromAPI} className="text-sm text-gray-500 dark:text-gray-400 border border-gray-300 dark:border-gray-600 rounded-lg w-40 bg-gray-50 dark:bg-gray-700 focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-500 dark:focus:border-blue-500 ">
                                <option>Archivos recientes</option>
                                {sheets.map((sheet, sheetIndex) => {
                                    return <option key={sheetIndex} value={sheet}>{sheet}</option>;
                                })}
                            </select>
                            <select id="selecttemplate" className="text-sm text-gray-500 dark:text-gray-400 border border-gray-300 dark:border-gray-600 rounded-lg w-80 bg-gray-50 dark:bg-gray-700 focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-500 dark:focus:border-blue-500 " onChange={(e) => changeSelectedTemplate(e)}>
                                <option>Seleccionar plantilla</option>
                                {templates.map((template) => {
                                    return <option value={template._id}>{template.name}</option>;
                                })}
                            </select>
                            <select id="selectejecutivo" className="text-sm text-gray-500 dark:text-gray-400 border border-gray-300 dark:border-gray-600 rounded-lg w-80 bg-gray-50 dark:bg-gray-700 focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-500 dark:focus:border-blue-500 " onChange={(e) => handleSelectedEjecutivo(e.target.value)}>
                                <option>Ejecutivo</option>
                                {ejecutivos.map((ejecutivo) => {
                                    return <option key={ejecutivo._id} value={ejecutivo._id}>{ejecutivo.firstName} {ejecutivo.lastName}</option>;
                                })}
                            </select>
                            <div className="flex items-center space-x-1">
                                <input
                                    type="text"
                                    placeholder="Valor fijo..."
                                    value={customFixedInput}
                                    onChange={(e) => setCustomFixedInput(e.target.value)}
                                    className="text-sm p-2 border border-gray-300 dark:border-gray-600 rounded-lg w-32 bg-gray-50 dark:bg-gray-700 focus:ring-blue-500 focus:border-blue-500 dark:text-white"
                                />
                                <button
                                    type="button"
                                    onClick={handleAddCustomFixedValue}
                                    className="px-3 py-2 text-xs font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-lg focus:outline-none flex items-center gap-1"
                                    title="Agregar valor fijo a la plantilla"
                                >
                                    + Valor Fijo
                                </button>
                            </div>
                            <div className="flex items-center space-x-1">
                                <select id="selectphone" className="text-sm text-gray-500 dark:text-gray-400 border border-gray-300 dark:border-gray-600 rounded-lg w-40 bg-gray-50 dark:bg-gray-700 focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-500 dark:focus:border-blue-500 " onChange={(e) => setSelectedPhoneColumn(e.target.value)}>
                                    <option>Telefono Col</option>
                                    {dataColumnNames(readedData).map((columnName, columnNameIndex) => {
                                        if (columnName === "checked") return null;
                                        return <option key={columnNameIndex} value={columnName}>{columnName}</option>;
                                    })}
                                </select>
                                <button
                                    type="button"
                                    title="Configurar teléfono y contactos"
                                    onClick={() => setIsPhoneModalOpen(true)}
                                    className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-white bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg focus:outline-none"
                                >
                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.532 1.532 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.532 1.532 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd"></path>
                                    </svg>
                                </button>
                            </div>
                            <div className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    id="backgroundSend"
                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                    onChange={(e) => setIsSendingOnBackground(e.target.checked)}
                                />
                                <label htmlFor="backgroundSend" className="text-sm text-gray-500 dark:text-gray-400">Segundo plano</label>
                            </div>
                            <button id="sendtemplate" onClick={sendTemplateMessage} type="button" className="text-white bg-[#1c71bd] hover:bg-[#1c71bd]/90 focus:ring-4 focus:outline-none focus:ring-[#1c71bd]/50 font-medium rounded-lg text-sm px-5 py-2 text-center inline-flex items-center dark:focus:ring-[#1c71bd]/55">
                                <svg fill="#ffffff" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" height="20px" stroke="#ffffff">
                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <g id="surface1">
                                            <path d="M2,3v7.8L18,12L2,13.2V21l20-9L2,3z"></path>
                                        </g>
                                        <rect className="st0" style={{ fill: "none" }} width="24" height="24"></rect>
                                    </g>
                                </svg>
                                &nbsp;Enviar Plantilla
                            </button>
                            <button id="loadexcelfile" type="button" onClick={(e) => { document.getElementById("excelfile").click() }} className="text-white bg-[#00873a] hover:bg-[#00873a]/90 focus:ring-4 focus:outline-none focus:ring-[#00873a]/50 font-medium rounded-lg text-sm px-5 py-2 text-center inline-flex items-center dark:focus:ring-[#00873a]/55">
                                <svg height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" fill="#000000">
                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <g>
                                            <path style={{ fill: "#ffffff" }} d="M25.162,3H16v2.984h3.031v2.031H16V10h3v2h-3v2h3v2h-3v2h3v2h-3v3h9.162 C25.623,23,26,22.609,26,22.13V3.87C26,3.391,25.623,3,25.162,3z M24,20h-4v-2h4V20z M24,16h-4v-2h4V16z M24,12h-4v-2h4V12z M24,8 h-4V6h4V8z"></path>
                                            <path style={{ fill: "#ffffff" }} d="M0,2.889v20.223L15,26V0L0,2.889z M9.488,18.08l-1.745-3.299c-0.066-0.123-0.134-0.349-0.205-0.678 H7.511C7.478,14.258,7.4,14.494,7.277,14.81l-1.751,3.27H2.807l3.228-5.064L3.082,7.951h2.776l1.448,3.037 c0.113,0.24,0.214,0.525,0.304,0.854h0.028c0.057-0.198,0.163-0.492,0.318-0.883l1.61-3.009h2.542l-3.037,5.022l3.122,5.107 L9.488,18.08L9.488,18.08z"></path>
                                        </g>
                                    </g>
                                </svg>
                                &nbsp;Cargar Archivo Excel
                            </button>
                            <button type="button" onClick={(e) => { driverObj.drive() }} className="text-white bg-[#dedede] hover:bg-[#dedede]/90 focus:ring-4 focus:outline-none focus:ring-[#dedede]/50 font-medium rounded-lg text-sm px-5 py-2 text-center inline-flex items-center dark:focus:ring-[#dedede]/55">
                                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#ffffff" strokeWidth="2"></path> <path d="M10.5 8.67709C10.8665 8.26188 11.4027 8 12 8C13.1046 8 14 8.89543 14 10C14 10.9337 13.3601 11.718 12.4949 11.9383C12.2273 12.0064 12 12.2239 12 12.5V12.5V13" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> <path d="M12 16H12.01" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                            </button>
                            <input id="excelfile" type="file" style={{ visibility: "hidden" }} accept=".xlsx" onChange={(e) => {
                                const file = e.target.files[0];
                                readExcelFile(file);
                            }
                            } />
                        </div>
                        <div className="flex items-center space-x-2">
                            {(search || Object.values(columnFilters).some((v) => v && v.trim() !== "")) && (
                                <button
                                    type="button"
                                    onClick={clearAllFilters}
                                    className="px-3 py-1.5 text-xs font-medium text-red-600 bg-red-50 hover:bg-red-100 dark:bg-red-950 dark:text-red-300 dark:hover:bg-red-900 border border-red-200 dark:border-red-800 rounded-lg transition-colors flex items-center gap-1"
                                    title="Limpiar todos los filtros"
                                >
                                    ✕ Limpiar Filtros
                                </button>
                            )}
                            <button
                                type="button"
                                onClick={() => setShowColumnFilters(!showColumnFilters)}
                                className={`px-3 py-1.5 text-xs font-medium border rounded-lg transition-colors flex items-center gap-1 ${
                                    showColumnFilters
                                        ? "text-blue-600 bg-blue-50 dark:bg-blue-950 dark:text-blue-300 border-blue-200 dark:border-blue-800"
                                        : "text-gray-600 bg-gray-50 dark:bg-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600"
                                }`}
                                title="Mostrar/Ocultar filtros por columna"
                            >
                                🔍 Filtros Columna {Object.values(columnFilters).filter((v) => v && v.trim() !== "").length > 0 && `(${Object.values(columnFilters).filter((v) => v && v.trim() !== "").length})`}
                            </button>
                        </div>
                        <label htmlFor="table-search" className="sr-only">Search</label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 rtl:inset-r-0 rtl:right-0 flex items-center ps-3 pointer-events-none">
                                <svg className="w-5 h-10 text-gray-500 dark:text-gray-400" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd"></path></svg>
                            </div>
                            <input type="text" value={search} onChange={(e) => setSearch(e.target.value)} id="table-search" className="block p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-40 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Search for items" />
                        </div>
                    </div>
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" id="columnnames">
                            <tr>
                                <th scope="col" className="p-4" key={0}>
                                    <div className="flex items-center">
                                        <input id="checkbox-all-search" onChange={(e) => checkAll(e)} type="checkbox" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                        <label htmlFor="checkbox-all-search" className="sr-only">checkbox</label>
                                    </div>
                                </th>
                                {
                                    dataColumnNames(readedData).map((columnName, columnNameIndex) => {
                                        if (columnName === "checked" || columnName === "sheettitle" || columnName === "_id") return null;
                                        const isSorted = sortConfig.key === columnName;
                                        return (
                                            <th key={columnNameIndex + 1} scope="col" className="px-6 py-3 select-none">
                                                <div className="flex items-center justify-between gap-2">
                                                    <span
                                                        className="cursor-pointer hover:underline flex-1"
                                                        onClick={() => {
                                                            if (!selectedVariables.includes(columnName)) {
                                                                setSelectedVariables([...selectedVariables, columnName]);
                                                            }
                                                        }}
                                                    >
                                                        {columnName}
                                                    </span>
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleSort(columnName);
                                                        }}
                                                        className="p-1 text-gray-400 hover:text-gray-600 dark:hover:text-white focus:outline-none"
                                                        title={`Ordenar por ${columnName}`}
                                                    >
                                                        {isSorted ? (sortConfig.direction === "asc" ? "▲" : "▼") : "⇅"}
                                                    </button>
                                                </div>
                                            </th>
                                        )
                                    })
                                }
                            </tr>
                            {showColumnFilters && dataColumnNames(readedData).length > 0 && (
                                <tr className="bg-gray-100 dark:bg-gray-800 border-t border-b border-gray-200 dark:border-gray-700">
                                    <td className="p-2 text-center">
                                        {Object.values(columnFilters).some((v) => v && v.trim() !== "") && (
                                            <button
                                                type="button"
                                                onClick={clearAllFilters}
                                                className="text-xs text-red-600 dark:text-red-400 hover:underline font-bold"
                                                title="Limpiar filtros de columna"
                                            >
                                                ✕
                                            </button>
                                        )}
                                    </td>
                                    {dataColumnNames(readedData).map((columnName, columnNameIndex) => {
                                        if (columnName === "checked" || columnName === "sheettitle" || columnName === "_id") return null;
                                        return (
                                            <td key={columnNameIndex + 1} className="px-2 py-1">
                                                <input
                                                    type="text"
                                                    placeholder={`Filtrar ${columnName}...`}
                                                    value={columnFilters[columnName] || ""}
                                                    onChange={(e) => handleColumnFilterChange(columnName, e.target.value)}
                                                    className="w-full text-xs p-1 font-normal normal-case text-gray-900 bg-white dark:bg-gray-700 dark:text-white border border-gray-300 dark:border-gray-600 rounded focus:ring-1 focus:ring-blue-500 focus:outline-none"
                                                />
                                            </td>
                                        );
                                    })}
                                </tr>
                            )}
                        </thead>
                        <tbody>
                            {
                                sortedData.map((row, rowIndex) => {
                                    return (
                                        <tr key={row._id || rowIndex} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                            <td className="w-4 p-4">
                                                <div className="flex items-center">
                                                    <input id={`checkbox-table-search-${rowIndex}`} checked={!!row.checked} onChange={(e) => checkIndividual(e, row)} type="checkbox" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                                    <label htmlFor={`checkbox-table-search-${rowIndex}`} className="sr-only">checkbox</label>
                                                </div>
                                            </td>
                                            {
                                                Object.keys(row).map((key, keyindex) => {
                                                    if (key === "checked" || key === "sheettitle" || key === "_id") return null;
                                                    if (key === "messageStatus") {
                                                        return (
                                                            <td key={keyindex} className="px-6 py-4">
                                                                {
                                                                    Array.isArray(row[key]) && row[key].map((status, statusIndex) => {
                                                                        return (
                                                                            <div key={statusIndex} className="flex flex-row">
                                                                                <p>
                                                                                    <span className="bg-gray-100 text-gray-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-300">{status.sentTemplate}:{status.status}</span>
                                                                                </p>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </td>
                                                        )
                                                    }
                                                    return (
                                                        <td key={key} className="px-2 py-2">
                                                            <input
                                                                type="text"
                                                                value={row[key] !== undefined && row[key] !== null ? row[key] : ""}
                                                                onChange={(e) => handleCellEdit(row, key, e.target.value)}
                                                                onBlur={() => handleCellBlur(row)}
                                                                className="bg-transparent border border-transparent hover:border-gray-300 dark:hover:border-gray-600 focus:border-blue-500 focus:bg-white dark:focus:bg-gray-700 focus:outline-none w-full px-2 py-1 text-sm text-gray-900 dark:text-white rounded transition-colors"
                                                            />
                                                        </td>
                                                    )
                                                })
                                            }
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div key={2} className="flex-1 w-100 bg-[#e5ddd5]" style={{ backgroundImage: "url('/chatbg.png')" }}>
                    <div className="flex flex-col">
                        <div className="bg-white h-6 w-full">
                            <p className="text-center font-bold text-md">{selectedTemplate ? selectedTemplate.name : 'tu plantilla'}</p>
                        </div>
                        <div className="p-4">
                            {
                                selectedTemplate && (
                                    <div id="templatemessage" className="flex-1 w-full bg-white p-2 rounded-tr-lg rounded-b-lg w-[300px]">
                                        <img src={selectedTemplate.image} />
                                        <p style={{ fontFamily: 'arial', fontSize: '13px' }} dangerouslySetInnerHTML={{ __html: selectedTemplate.body }}></p>
                                        {
                                            selectedTemplate.buttonparameters && (
                                                selectedTemplate.buttonparameters.map((buttonparameter, index) => {
                                                    return (
                                                        <div className="flex flex-row border-t-[#000] px-10" key={index}>
                                                            <svg fill="#000ba3" height="15px" width="15px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.676 26.676" stroke="#000ba3"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M26.105,21.891c-0.229,0-0.439-0.131-0.529-0.346l0,0c-0.066-0.156-1.716-3.857-7.885-4.59 c-1.285-0.156-2.824-0.236-4.693-0.25v4.613c0,0.213-0.115,0.406-0.304,0.508c-0.188,0.098-0.413,0.084-0.588-0.033L0.254,13.815 C0.094,13.708,0,13.528,0,13.339c0-0.191,0.094-0.365,0.254-0.477l11.857-7.979c0.175-0.121,0.398-0.129,0.588-0.029 c0.19,0.102,0.303,0.295,0.303,0.502v4.293c2.578,0.336,13.674,2.33,13.674,11.674c0,0.271-0.191,0.508-0.459,0.562 C26.18,21.891,26.141,21.891,26.105,21.891z"></path> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </g> </g></svg>
                                                            <span className="ml-4">{selectedButtonParameters.length > 0 ? buttonparameter.label : `BOTON ${index}`}</span>
                                                        </div>
                                                    )
                                                }
                                                )
                                            )
                                        }
                                        {
                                            selectedVariables.length > 0 && (
                                                <div className="mt-4 p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg border dark:border-gray-600">
                                                    <p className="text-xs font-semibold text-gray-700 dark:text-gray-300 mb-2">Variables Asignadas:</p>
                                                    <div className="flex flex-wrap gap-1.5">
                                                        {selectedVariables.map((v, idx) => {
                                                            const isFixed = v.startsWith("FIXED_VAL:");
                                                            const label = isFixed ? `"${v.replace("FIXED_VAL:", "")}"` : v;
                                                            return (
                                                                <span key={idx} className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded ${isFixed ? "bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-200 font-medium" : "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200"}`}>
                                                                    <span className="font-bold">{`{{${idx + 1}}}`}:</span> {label}
                                                                    <button type="button" onClick={() => removeVariableIndex(idx)} className="hover:text-red-600 font-bold ml-0.5">✕</button>
                                                                </span>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
            {isPhoneModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md overflow-hidden">
                        <div className="flex justify-between items-center px-6 py-4 border-b dark:border-gray-700 bg-gray-50 dark:bg-gray-900">
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                                <svg className="w-5 h-5 text-blue-600 dark:text-blue-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.532 1.532 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.532 1.532 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd"></path>
                                </svg>
                                Configuración de Teléfono y Contactos
                            </h3>
                            <button
                                onClick={() => setIsPhoneModalOpen(false)}
                                className="text-gray-400 hover:text-gray-600 dark:hover:text-white"
                            >
                                ✕
                            </button>
                        </div>
                        <div className="p-6 space-y-4">
                            <div className="space-y-3">
                                <label className="flex items-center space-x-3 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={phoneConfig.autoFormat}
                                        onChange={(e) => setPhoneConfig({ ...phoneConfig, autoFormat: e.target.checked })}
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:bg-gray-700"
                                    />
                                    <span className="text-sm font-medium text-gray-900 dark:text-gray-300">
                                        Verificación y formato automático al enviar
                                    </span>
                                </label>
                                <p className="text-xs text-gray-500 dark:text-gray-400 pl-7">
                                    Limpia caracteres especiales/espacios y valida el formato para WhatsApp.
                                </p>
                            </div>

                            <div className="space-y-2 pt-2 border-t dark:border-gray-700">
                                <label className="block text-sm font-medium text-gray-900 dark:text-gray-300">
                                    Código de país por defecto
                                </label>
                                <input
                                    type="text"
                                    value={phoneConfig.defaultCountryCode}
                                    onChange={(e) => setPhoneConfig({ ...phoneConfig, defaultCountryCode: e.target.value })}
                                    placeholder="507"
                                    className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                                />
                                <p className="text-xs text-gray-500 dark:text-gray-400">
                                    Se agregará al inicio si el número de teléfono no lo posee.
                                </p>
                            </div>

                            <div className="pt-2 border-t dark:border-gray-700">
                                <button
                                    type="button"
                                    onClick={applyPhoneFormattingToTable}
                                    className="w-full py-2 px-4 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 font-medium rounded-lg text-sm transition-colors"
                                >
                                    ⚡ Aplicar formato a la tabla ahora
                                </button>
                            </div>

                            <div className="space-y-3 pt-2 border-t dark:border-gray-700">
                                <label className="flex items-center space-x-3 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={phoneConfig.saveToContacts}
                                        onChange={(e) => setPhoneConfig({ ...phoneConfig, saveToContacts: e.target.checked })}
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:bg-gray-700"
                                    />
                                    <span className="text-sm font-medium text-gray-900 dark:text-gray-300">
                                        Guardar/Actualizar columnas en Contactos al enviar
                                    </span>
                                </label>
                                <p className="text-xs text-gray-500 dark:text-gray-400 pl-7">
                                    Envía todas las columnas (nombre, póliza, etc.) en formato JSON al endpoint de contactos.
                                </p>
                            </div>
                        </div>
                        <div className="flex justify-end px-6 py-4 bg-gray-50 dark:bg-gray-900 border-t dark:border-gray-700">
                            <button
                                type="button"
                                onClick={() => setIsPhoneModalOpen(false)}
                                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg text-sm"
                            >
                                Listo
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
